import axios from '@/lib/AxApi';

export default {
    selectRow(params, cb)
    {
        axios.get('/IrCodes/selectRow',
            {
                params,
            })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    save(params, cb)
    {
        if (typeof params.id !== 'undefined' && params.id != '')
        {
            axios.post('/IrCodes/updateRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
        else
        {
            axios.post('/IrCodes/insertRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
    },
    deleteRow(params, cb)
    {
        axios.post('/IrCodes/deleteRow', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    startIrLearn(params, cb)
    {
        axios.post('/IrCodes/startIrLearn', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    sendCode(params, cb)
    {
        axios.post('/IrCodes/sendCode', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
};
